module.exports = __webpack_public_path__ + "static/media/ка.80830410.mp3";